import React, { useRef, useState } from "react";
import YouTube from "react-youtube";
import { Music, PauseCircle, PlayCircle } from "lucide-react";
import "../../CSS/musicplayer.css";

const CardMusicPlayer = ({ data, playOnOpen, isPreviewMode = false, onMusicReady }) => {
    const [isPlaying, setIsPlaying] = useState(false);


    const playerRef = useRef(null);

    const fallbackTitle = "Tajuk Lagu";
    const fallbackURL = "";
    const fallbackDuration = "0";

    const displayTitle = (isPreviewMode && !data.musicTitle) ? fallbackTitle : data.musicTitle;
    const displayURL = (isPreviewMode && !data.musicYoutubeURL) ? fallbackURL : data.musicYoutubeURL;
    const displayDuration = (isPreviewMode && !data.musicStartDuration) ? fallbackDuration : data.musicStartDuration;

    const extractVideoId = (url) => {
        if (!url) return "";
        const match = url.match(
            /(?:youtube\.com\/.*v=|youtu\.be\/)([^&?/]+)/ // handles both formats
        );
        return match ? match[1] : url; // fallback if already an ID
    };

    const videoId = extractVideoId(displayURL);

    const opts = {
        playerVars: {
            autoplay: 0,
            loop: 1,
            playlist: videoId,
            start: Number(displayDuration) || 0,
        },
    };

    const onReady = (event) => {
        playerRef.current = event.target;
        if (onMusicReady) onMusicReady();
    };

    React.useEffect(() => {
        if (playOnOpen && playerRef.current) {
            playerRef.current.playVideo();
            setIsPlaying(true);
        }
    }, [playOnOpen]);

    const isTogglingRef = useRef(false);

    const togglePlay = () => {
        if (!playerRef.current) return;

        // Prevent rapid-fire clicks while the player is transitioning
        if (isTogglingRef.current) return;
        isTogglingRef.current = true;

        try {
            const state = playerRef.current.getPlayerState?.();
            // YouTube player states: -1=unstarted, 0=ended, 1=playing, 2=paused, 3=buffering, 5=cued
            const playerIsPlaying = state === 1 || state === 3;

            if (playerIsPlaying) {
                playerRef.current.pauseVideo();
                setIsPlaying(false);
            } else {
                playerRef.current.playVideo();
                setIsPlaying(true);
            }
        } catch (err) {
            console.warn("Music player toggle error:", err);
        } finally {
            // Release the lock after a short delay to prevent double-clicks
            setTimeout(() => {
                isTogglingRef.current = false;
            }, 400);
        }
    };


    const [cardOpened, setCardOpened] = React.useState(false);


    return (
        <>
            <div
                style={{
                    position: "absolute",
                    width: "1px",
                    height: "1px",
                    opacity: 0,
                    pointerEvents: "none",
                    overflow: "hidden",
                }}
            >
                {videoId && (
                    <YouTube videoId={videoId} opts={opts} onReady={onReady} onError={(e) => console.warn("YouTube error:", e.data)} />
                )}
            </div>


            {/* Floating music control UI */}
            <div className="music-player" onClick={togglePlay}>
                {isPlaying ? (
                    <PauseCircle size={18} style={{ marginRight: "6px" }} />
                ) : (
                    <PlayCircle size={18} style={{ marginRight: "6px" }} />
                )}
                <span>{displayTitle}</span>
            </div>
        </>
    );
};

export default CardMusicPlayer;
